(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-cards"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const sliders = document.querySelectorAll('[data-cards-slider]');

    sliders.forEach((slider) => {
      const section = slider.closest('.c-cards');
      const pagination = section.querySelector('[data-cards-pagination]');
      const dots = pagination ? pagination.querySelectorAll('.c-cards__pagination-dot') : [];
      const cards = slider.querySelectorAll('.c-card');

      if (dots.length === 0 || cards.length === 0) return;

      // Update active dot based on scroll position
      function updateActiveDot() {
        const scrollLeft = slider.scrollLeft;
        const cardWidth = cards[0].offsetWidth;
        const activeIndex = Math.round(scrollLeft / cardWidth);

        dots.forEach((dot, index) => {
          if (index === activeIndex) {
            dot.classList.add('active');
          } else {
            dot.classList.remove('active');
          }
        });
      }

      // Scroll to card on dot click
      dots.forEach((dot, index) => {
        dot.addEventListener('click', function () {
          const cardWidth = cards[0].offsetWidth;
          slider.scrollTo({
            left: cardWidth * index,
            behavior: 'smooth',
          });
        });
      });

      // Listen to scroll events
      let scrollTimeout;
      slider.addEventListener('scroll', function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(updateActiveDot, 50);
      });

      // Initialize
      updateActiveDot();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-doble-hero-timer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const timers = document.querySelectorAll('[data-countdown-timer]');

    timers.forEach(function (timerElement) {
      const endDateStr = timerElement.dataset.endDate;
      const timezone = timerElement.dataset.timezone || 'America/New_York';

      if (!endDateStr || typeof luxon === 'undefined') {
        console.warn('Countdown timer: Missing end date or Luxon library not loaded');
        return;
      }

      const DateTime = luxon.DateTime;
      // Parse the end date in the specified timezone
      const endDate = DateTime.fromISO(endDateStr, { zone: timezone });

      if (!endDate.isValid) {
        console.warn('Countdown timer: Invalid end date format');
        return;
      }

      // Main timer elements
      const daysEl = timerElement.querySelector('[data-days]');
      const hoursEl = timerElement.querySelector('[data-hours]');
      const minutesEl = timerElement.querySelector('[data-minutes]');
      const secondsEl = timerElement.querySelector('[data-seconds]');

      // Find corresponding mini timer
      const section = timerElement.closest('section');
      const sectionId = section ? section.id : null;
      const miniTimer = sectionId ? document.querySelector(`[data-mini-timer][data-section-id="${sectionId}"]`) : null;
      const miniTimerBox = miniTimer ? miniTimer.querySelector('[data-mini-timer-box]') : null;

      // Mini timer elements
      const miniDaysEl = miniTimer ? miniTimer.querySelector('[data-mini-days]') : null;
      const miniHoursEl = miniTimer ? miniTimer.querySelector('[data-mini-hours]') : null;
      const miniMinutesEl = miniTimer ? miniTimer.querySelector('[data-mini-minutes]') : null;
      const miniSecondsEl = miniTimer ? miniTimer.querySelector('[data-mini-seconds]') : null;

      function updateTimer() {
        const now = DateTime.now();
        const diff = endDate.diff(now, ['days', 'hours', 'minutes', 'seconds']);

        if (diff.as('seconds') <= 0) {
          // Timer expired
          timerElement.classList.add('is-expired');
          if (miniTimerBox) miniTimerBox.classList.add('is-expired');
          return;
        }

        const days = Math.floor(diff.days);
        const hours = Math.floor(diff.hours);
        const minutes = Math.floor(diff.minutes);
        const seconds = Math.floor(diff.seconds);

        // Update main timer
        if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
        if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
        if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
        if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');

        // Update mini timer
        if (miniDaysEl) miniDaysEl.textContent = String(days).padStart(2, '0');
        if (miniHoursEl) miniHoursEl.textContent = String(hours).padStart(2, '0');
        if (miniMinutesEl) miniMinutesEl.textContent = String(minutes).padStart(2, '0');
        if (miniSecondsEl) miniSecondsEl.textContent = String(seconds).padStart(2, '0');
      }

      // Initial update
      updateTimer();

      // Update every second
      setInterval(updateTimer, 1000);

      // Scroll detection for mini timer visibility
      if (miniTimer && section) {
        function checkVisibility() {
          const rect = section.getBoundingClientRect();
          const isHeroVisible = rect.bottom > 0;

          if (isHeroVisible) {
            miniTimer.classList.remove('is-visible');
          } else {
            miniTimer.classList.add('is-visible');
          }
        }

        // Check on scroll
        window.addEventListener('scroll', checkVisibility, { passive: true });

        // Initial check
        checkVisibility();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-doble-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const videoPlayerContainers = document.querySelectorAll('[data-video-player]');

    videoPlayerContainers.forEach(function (container) {
      const playButton = container.querySelector('[data-play-button]');
      const video = container.querySelector('.c-doble-hero__video-full');

      if (playButton && video) {
        playButton.addEventListener('click', function () {
          container.classList.add('is-playing');
          video.play();
        });

        // When video ends, show play button again
        video.addEventListener('ended', function () {
          container.classList.remove('is-playing');
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-feature-carosel_activation"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Find all carousel wrappers with the class pattern
    const carousels = document.querySelectorAll('[id*="carousel-wrapper-"]');
    
    carousels.forEach(function(carousel) {
      if (!carousel) return;

      // Ensure infinite scroll by monitoring animation
      carousel.addEventListener('animationiteration', function() {
        // Animation will restart automatically due to infinite iteration
        console.log('Carousel animation cycle completed - continuing infinitely');
      });

      // Add performance optimization
      carousel.style.willChange = 'transform';
      
      // Ensure the animation never stops when visible
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Resume animation when visible
            carousel.style.animationPlayState = 'running';
          }
        });
      });
      
      observer.observe(carousel);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-featured-carousel"] && !Shopify.designMode) return;
  try {
    
  // Carousel is handled by CSS animations for better performance
  // Hover pause is handled by CSS :hover pseudo-class

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const toggles = document.querySelectorAll('[data-footer-toggle]');

    // Only enable toggle functionality on mobile/tablet
    function initFooterToggles() {
      const isMobile = window.innerWidth < 978;

      toggles.forEach(function (toggle) {
        const content = toggle.nextElementSibling;
        const caret = toggle.querySelector('.c-footer__caret');

        if (isMobile) {
          toggle.style.cursor = 'pointer';
          toggle.style.pointerEvents = 'auto';

          toggle.addEventListener('click', function () {
            const isActive = content.classList.contains('active');

            // Close all other menus
            document.querySelectorAll('[data-footer-content]').forEach(function (item) {
              item.classList.remove('active');
            });
            document.querySelectorAll('.c-footer__caret').forEach(function (item) {
              item.style.transform = 'rotate(0deg)';
            });

            // Toggle current menu
            if (!isActive) {
              content.classList.add('active');
              if (caret) {
                caret.style.transform = 'rotate(180deg)';
              }
            }
          });
        } else {
          toggle.style.cursor = 'default';
          toggle.style.pointerEvents = 'none';
          content.classList.add('active');
        }
      });
    }

    initFooterToggles();

    // Re-initialize on window resize
    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        initFooterToggles();
      }, 250);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-hero-VIP"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const videoWrapper = document.querySelector('[data-video-wrapper]');
    
    if (!videoWrapper) return;
    
    const video = videoWrapper.querySelector('video');
    const overlay = videoWrapper.querySelector('[data-video-overlay]');
    const playButton = videoWrapper.querySelector('[data-play-button]');
    
    if (!video || !overlay || !playButton) return;
    
    // Play video when clicking on the overlay or play button
    overlay.addEventListener('click', function() {
      video.play();
      overlay.classList.add('is-hidden');
    });
    
    // Show overlay again when video ends (if not looping)
    video.addEventListener('ended', function() {
      if (!video.loop) {
        overlay.classList.remove('is-hidden');
      }
    });
    
    // Hide overlay when video starts playing
    video.addEventListener('play', function() {
      overlay.classList.add('is-hidden');
    });
    
    // Show overlay when video is paused
    video.addEventListener('pause', function() {
      overlay.classList.remove('is-hidden');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-hero-about-us"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function ytId(url) {
      var m = url.match(/(?:youtu\.be\/|[?&]v=|\/embed\/|\/shorts\/)([\w-]{11})/);
      return m ? m[1] : '';
    }

    function vimeoId(url) {
      var m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      return m ? m[1] : '';
    }

    function buildEmbed(url, loop) {
      if (url.indexOf('youtu') !== -1) {
        var id = ytId(url);
        var p = 'autoplay=1&mute=1&controls=0&playsinline=1&rel=0&modestbranding=1&showinfo=0&disablekb=1&fs=0&iv_load_policy=3';
        if (loop && id) { p += '&loop=1&playlist=' + id; }
        return 'https://www.youtube.com/embed/' + id + '?' + p;
      }
      if (url.indexOf('vimeo') !== -1) {
        var vid = vimeoId(url);
        var vp = 'background=1&autoplay=1&muted=1&playsinline=1';
        if (loop) { vp += '&loop=1'; }
        return 'https://player.vimeo.com/video/' + vid + '?' + vp;
      }
      return url;
    }

    function activate(media) { if (media) media.classList.add('is-video-active'); }

    function initEmbed(el) {
      var url = el.dataset.embedUrl;
      if (!url) return;
      var loop = el.dataset.loop === 'true';
      var iframe = document.createElement('iframe');
      iframe.src = buildEmbed(url, loop);
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('aria-hidden', 'true');
      iframe.tabIndex = -1;
      iframe.title = 'Background video';
      iframe.addEventListener('load', function () {
        activate(el.closest('.c-hero-about-us__media'));
      });
      el.appendChild(iframe);
    }

    function initHostedVideo(v) {
      var media = v.closest('.c-hero-about-us__media');
      v.muted = true;          // set the property, not just the attribute
      v.playsInline = true;

      function play() {
        if (!v.muted || !v.paused) { activate(media); return; }
        var p = v.play();
        if (p && typeof p.catch === 'function') { p.catch(function () {}); }
      }

      v.addEventListener('playing', function () { activate(media); });
      v.addEventListener('canplay', play);
      if (v.readyState >= 2) { play(); }

      // Fallback for strict autoplay policies: kick playback on the first
      // interaction anywhere on the page.
      function kick() {
        play();
        document.removeEventListener('pointerdown', kick);
        document.removeEventListener('touchstart', kick);
        document.removeEventListener('keydown', kick);
      }
      document.addEventListener('pointerdown', kick, { once: true });
      document.addEventListener('touchstart', kick, { once: true });
      document.addEventListener('keydown', kick, { once: true });
    }

    document.querySelectorAll('.c-hero-about-us__media[data-has-video]').forEach(function (media) {
      if (media.dataset.hauInit === 'true') return;
      media.dataset.hauInit = 'true';
      var v = media.querySelector('video.c-hero-about-us__video');
      if (v) { initHostedVideo(v); }
      var embed = media.querySelector('.c-hero-about-us__video--embed');
      if (embed) { initEmbed(embed); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-hero-auto-scroll"] && !Shopify.designMode) return;
  try {
    
  class HeroAutoScroll {
    constructor(section) {
      this.section = section;
      this.speed = parseInt(section.dataset.scrollSpeed) || 30;
      this.tracks = section.querySelectorAll('[class*="c-hero-auto-scroll__track--"]');
      this.observer = null;
      this.init();
    }

    init() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.tracks.forEach((track) => {
              track.style.animationPlayState = entry.isIntersecting ? 'running' : 'paused';
            });
          });
        },
        { threshold: 0.1 }
      );

      this.observer.observe(this.section);

      /* this.section.addEventListener('mouseenter', () => this.pause());
      this.section.addEventListener('mouseleave', () => this.resume()); */
    }

    /* pause() {
      this.tracks.forEach((track) => {
        track.style.animationPlayState = 'paused';
      });
    }

    resume() {
      this.tracks.forEach((track) => {
        track.style.animationPlayState = 'running';
      });
    } */

    destroy() {
      if (this.observer) this.observer.disconnect();
      this.section.removeEventListener('mouseenter', () => this.pause());
      this.section.removeEventListener('mouseleave', () => this.resume());
    }
  }

  /* Initialize on load */
  document.querySelectorAll('[data-sl-id="sl-section-hero-auto-scroll-v1"]').forEach((section) => {
    new HeroAutoScroll(section);
  });

  /* Handle Shopify theme editor events */
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-sl-id="sl-section-hero-auto-scroll-v1"]');
    if (section) new HeroAutoScroll(section);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('[data-sl-id="sl-section-hero-auto-scroll-v1"]');
    if (section && section._heroAutoScroll) section._heroAutoScroll.destroy();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-hero-banner"] && !Shopify.designMode) return;
  try {
    
  // Optional: Add parallax effect or other interactions
  document.addEventListener('DOMContentLoaded', function () {
    // Hero banner interactions can be added here
    console.log('--DEBUG, DEVELOPMENT MODE-- C Hero Banner loaded');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-hero-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHeroCollectionSwiper() {
      const swiperContainers = document.querySelectorAll('[data-hero-tabs-swiper]');

      swiperContainers.forEach(function (container) {
        const sectionId = container.getAttribute('data-hero-tabs-swiper');
        const scrollbarEl = document.querySelector('[data-hero-tabs-scrollbar="' + sectionId + '"]');
        const fillEl = scrollbarEl ? scrollbarEl.querySelector('.c-hero-collection__scrollbar-fill') : null;

        function updateProgressBar(swiper) {
          if (!fillEl) return;
          var totalWidth = swiper.virtualSize;
          var viewportWidth = swiper.size;
          if (totalWidth <= viewportWidth) {
            fillEl.style.width = '100%';
            return;
          }
          var viewportRatio = viewportWidth / totalWidth;
          var progress = Math.max(0, Math.min(1, swiper.progress));
          var fillWidth = viewportRatio + progress * (1 - viewportRatio);
          fillEl.style.width = (fillWidth * 100) + '%';
        }

        new Swiper(container, {
          slidesPerView: 'auto',
          spaceBetween: 12,
          freeMode: true,
          grabCursor: true,
          on: {
            init: function (swiper) {
              updateProgressBar(swiper);
            },
            progress: function (swiper) {
              updateProgressBar(swiper);
            },
          },
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHeroCollectionSwiper);
    } else {
      initHeroCollectionSwiper();
    }

    /* Support Shopify theme editor reload */
    if (Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (event) {
        if (event.target.querySelector('[data-hero-tabs-swiper]')) {
          initHeroCollectionSwiper();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-hero-collection2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHeroCollection2Swiper() {
      const swiperContainers = document.querySelectorAll('[data-hero-collection2-tabs-swiper]');

      swiperContainers.forEach(function (container) {
        const sectionId = container.getAttribute('data-hero-collection2-tabs-swiper');
        const scrollbarEl = document.querySelector('[data-hero-collection2-tabs-scrollbar="' + sectionId + '"]');
        const fillEl = scrollbarEl ? scrollbarEl.querySelector('.c-hero-collection2__scrollbar-fill') : null;

        function updateProgressBar(swiper) {
          if (!fillEl) return;
          var totalWidth = swiper.virtualSize;
          var viewportWidth = swiper.size;
          if (totalWidth <= viewportWidth) {
            fillEl.style.width = '100%';
            return;
          }
          var viewportRatio = viewportWidth / totalWidth;
          var progress = Math.max(0, Math.min(1, swiper.progress));
          var fillWidth = viewportRatio + progress * (1 - viewportRatio);
          fillEl.style.width = (fillWidth * 100) + '%';
        }

        new Swiper(container, {
          slidesPerView: 'auto',
          spaceBetween: 12,
          freeMode: true,
          grabCursor: true,
          on: {
            init: function (swiper) {
              updateProgressBar(swiper);
            },
            progress: function (swiper) {
              updateProgressBar(swiper);
            },
          },
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHeroCollection2Swiper);
    } else {
      initHeroCollection2Swiper();
    }

    /* Support Shopify theme editor reload */
    if (Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (event) {
        if (event.target.querySelector('[data-hero-collection2-tabs-swiper]')) {
          initHeroCollection2Swiper();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-hero-varc"] && !Shopify.designMode) return;
  try {
    
  // ---- Swiper init ----
  function heroVarcInitSwipers(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-hero-varc-swiper]').forEach(function (container) {
      if (typeof Swiper === 'undefined') return;
      if (container._swiperInstance) return;
      var paginationEl = container.querySelector('.c-hero-varc__pagination');
      container._swiperInstance = new Swiper(container, {
        slidesPerView: 1,
        spaceBetween: 8,
        pagination: { el: paginationEl, clickable: true },
        breakpoints: { 480: { spaceBetween: 12 }, 768: { spaceBetween: 16 } }
      });
    });
  }

  // ---- YouTube ID helper ----
  function heroVarcYouTubeId(url) {
    var m = (url || '').match(/(?:youtube\.com\/(?:[^\/\n]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\n ]{11})/);
    return m ? m[1] : null;
  }

  // ---- Event delegation: play & close (works even if DOM inserted late) ----
  document.addEventListener('click', function (e) {
    // Play button
    var btn = e.target.closest('[data-play-btn]');
    if (btn) {
      var imageCol = btn.closest('.c-hero-varc__image-col');
      if (!imageCol) return;
      var poster = imageCol.querySelector('.c-hero-varc__media-poster');
      var videoContainer = imageCol.querySelector('[data-video-container]');
      if (!videoContainer) return;

      if (poster) poster.classList.add('c-hero-varc__media-poster--hidden');
      videoContainer.classList.add('is-active');
      videoContainer.removeAttribute('aria-hidden');

      var videoType = btn.getAttribute('data-video-type');

      if (videoType === 'youtube') {
        var placeholder = videoContainer.querySelector('.c-hero-varc__youtube-placeholder');
        if (placeholder && !videoContainer.querySelector('iframe')) {
          var videoId = heroVarcYouTubeId(placeholder.getAttribute('data-youtube-url') || '');
          if (videoId) {
            var iframe = document.createElement('iframe');
            iframe.src = 'https://www.youtube-nocookie.com/embed/' + videoId + '?autoplay=1&rel=0&modestbranding=1';
            iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
            iframe.setAttribute('allowfullscreen', '');
            iframe.setAttribute('title', 'Hero video');
            placeholder.replaceWith(iframe);
          }
        }
      } else if (videoType === 'shopify') {
        var video = videoContainer.querySelector('video');
        if (video) {
          video.muted = false;
          video.play().catch(function () {
            video.muted = true;
            video.play();
          });
        }
      }
      return;
    }

    // Close button
    var closeBtn = e.target.closest('[data-close-video]');
    if (closeBtn) {
      var imageCol2 = closeBtn.closest('.c-hero-varc__image-col');
      if (!imageCol2) return;
      var poster2 = imageCol2.querySelector('.c-hero-varc__media-poster');
      var videoContainer2 = imageCol2.querySelector('[data-video-container]');
      if (!videoContainer2) return;

      if (poster2) poster2.classList.remove('c-hero-varc__media-poster--hidden');
      videoContainer2.classList.remove('is-active');
      videoContainer2.setAttribute('aria-hidden', 'true');

      var video2 = videoContainer2.querySelector('video');
      if (video2) { video2.pause(); video2.currentTime = 0; }

      var iframe2 = videoContainer2.querySelector('iframe');
      if (iframe2) {
        var storedUrl = videoContainer2.getAttribute('data-youtube-url') || '';
        var ph = document.createElement('div');
        ph.className = 'c-hero-varc__youtube-placeholder';
        ph.setAttribute('data-youtube-url', storedUrl);
        iframe2.replaceWith(ph);
      }
    }
  });

  // ---- Init swipers on load and theme-editor section load ----
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { heroVarcInitSwipers(); });
  } else {
    heroVarcInitSwipers();
  }

  document.addEventListener('shopify:section:load', function (e) {
    heroVarcInitSwipers(e.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-hero-with-video-card"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const videoCards = document.querySelectorAll('.c-hero-with-video-card__video-card');
    videoCards.forEach(function (card) {
      const playBtn = card.querySelector('.c-hero-with-video-card__play-btn');
      if (!playBtn) return;

      playBtn.addEventListener('click', function () {
        card.classList.add('is-playing');

        /* Try to auto-play the Wistia video */
        const wistiaPlayer = card.querySelector('wistia-player');
        if (wistiaPlayer && wistiaPlayer.play) {
          wistiaPlayer.play();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    console.log('🚀 [C-Hero] Initializing...');

    const section = document.querySelector('.c-hero');
    if (!section) {
      console.error('❌ [C-Hero] Section not found');
      return;
    }

    console.log('✅ [C-Hero] Initialization complete!');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-image-with-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelector('.c-image-with-content');
    if (!section) return;

    const cta = section.querySelector('.c-image-with-content__cta');
    if (!cta) return;

    cta.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (!href) return;

      // Check if it's an anchor link (starts with # or contains # for same-page navigation)
      const hashIndex = href.indexOf('#');
      if (hashIndex === -1) return;

      const hash = href.substring(hashIndex);
      const targetId = hash.substring(1);

      // Check if the link is for the current page
      const isCurrentPage =
        hashIndex === 0 ||
        href.substring(0, hashIndex) === '' ||
        href.substring(0, hashIndex) === window.location.pathname ||
        href.substring(0, hashIndex) === window.location.origin + window.location.pathname;

      if (isCurrentPage && targetId) {
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          e.preventDefault();
          targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
          // Update URL hash without reloading
          history.pushState(null, null, hash);
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-image-with-text-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const tabsContainers = document.querySelectorAll('[data-tabs-container]');

    tabsContainers.forEach(function (container) {
      const tabs = container.querySelectorAll('[data-tab-item]');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          // Remove active class from all tabs
          tabs.forEach(function (t) {
            t.classList.remove('is-active');
          });

          // Add active class to clicked tab
          tab.classList.add('is-active');
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-journey-stages"] && !Shopify.designMode) return;
  try {
    
  /* C Journey Stages — timeline tabs.
     Binds on DOMContentLoaded AND shopify:section:load, so the section is alive
     in the theme editor (c-tabs-faqs only does the first and is dead there).
     Section javascript is bundled and deferred by Shopify, so it can also run
     after DOMContentLoaded has already fired — hence the readyState check.
     init() is idempotent: a re-render gives a fresh element with no bound flag. */
  (function () {
    const ROOT_SELECTOR = '[data-journey-stages]';

    function cssId(value) {
      return window.CSS && CSS.escape ? CSS.escape(value) : value;
    }

    function init(root) {
      if (!root || root.dataset.journeyBound === 'true') return;
      root.dataset.journeyBound = 'true';

      const sectionId = root.dataset.sectionId || root.id;
      if (!sectionId) return;

      const scope = `#${cssId(sectionId)}`;
      const stops = Array.from(document.querySelectorAll(`${scope} [data-journey-stop]`));
      const panels = Array.from(document.querySelectorAll(`${scope} [data-journey-panel]`));
      const timeline = document.querySelector(`${scope} [data-journey-timeline]`);
      if (stops.length === 0) return;

      function activate(stageId, moveFocus) {
        stops.forEach((stop) => {
          const selected = stop.dataset.stageId === stageId;
          stop.setAttribute('aria-selected', selected ? 'true' : 'false');
          stop.setAttribute('tabindex', selected ? '0' : '-1');
          if (!selected) return;
          if (moveFocus) stop.focus();
          // Only nudge the scroller when it actually overflows, so a click on a
          // desktop-width timeline never scrolls the page.
          if (timeline && timeline.scrollWidth > timeline.clientWidth) {
            stop.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          }
        });

        panels.forEach((panel) => {
          const selected = panel.dataset.stageId === stageId;
          panel.dataset.active = selected ? 'true' : 'false';
          panel.setAttribute('tabindex', selected ? '0' : '-1');
          if (selected) {
            panel.removeAttribute('aria-hidden');
          } else {
            panel.setAttribute('aria-hidden', 'true');
          }
        });
      }

      stops.forEach((stop, index) => {
        stop.addEventListener('click', function () {
          activate(stop.dataset.stageId, false);
        });

        stop.addEventListener('keydown', function (event) {
          let target = -1;
          switch (event.key) {
            case 'ArrowRight':
              target = (index + 1) % stops.length;
              break;
            case 'ArrowLeft':
              target = (index - 1 + stops.length) % stops.length;
              break;
            case 'Home':
              target = 0;
              break;
            case 'End':
              target = stops.length - 1;
              break;
            default:
              return;
          }
          event.preventDefault();
          activate(stops[target].dataset.stageId, true);
        });
      });
    }

    function boot(scope) {
      const context = scope || document;
      if (context.matches && context.matches(ROOT_SELECTOR)) {
        init(context);
        return;
      }
      if (!context.querySelectorAll) return;
      context.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
        init(root);
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });

    document.addEventListener('shopify:section:load', function (event) {
      boot(event.target);
    });

    if (document.readyState !== 'loading') boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-products-showcase"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-sl-id="sl-section-products-showcase-v1"]').forEach(function(section) {
      var cards = section.querySelectorAll('.c-products-showcase__card');
      if (!cards.length) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        cards.forEach(function(card) { card.classList.add('is-visible'); });
        return;
      }

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            cards.forEach(function(card) {
              card.classList.add('is-visible');
            });
            observer.disconnect();
          }
        });
      }, {
        threshold: 0.15,
        rootMargin: '0px 0px -50px 0px'
      });

      observer.observe(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-testimonials-swiper"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SELECTOR = '[data-cts-swiper]';
    var instances = new WeakMap();

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    /* Play the active slide's video, pause the rest. Uses activeIndex rather than
       the active class so it never depends on Swiper's class-update timing. */
    function syncVideos(swiper) {
      var offscreen = swiper.el.dataset.ctsVisible === 'false';

      swiper.slides.forEach(function (slide, index) {
        var video = slide.querySelector('video');
        if (!video) return;

        if (index === swiper.activeIndex && !offscreen) {
          video.muted = true;
          var playing = video.play();
          if (playing && playing.catch) playing.catch(function () {});
        } else {
          video.pause();
        }
      });
    }

    /* Stop autoplay and video while the section is off screen. */
    function observeVisibility(el, swiper, autoplayOn) {
      if (!('IntersectionObserver' in window)) return;

      var observer = new IntersectionObserver(
        function (entries) {
          var visible = entries[0].isIntersecting;
          el.dataset.ctsVisible = visible ? 'true' : 'false';

          if (autoplayOn && swiper.autoplay) {
            if (visible) swiper.autoplay.start();
            else swiper.autoplay.stop();
          }
          /* Hosts that render this section hidden/zero-size before revealing it
             (theme editor iframes, tabs, accordions) make Swiper measure 0-width
             slides on init, which leaves every slide the idle size with none
             marked active. Re-measuring the moment the section becomes visible
             fixes that without waiting on Swiper's own resize detection. */
          if (visible) { swiper.update(); recenter(swiper); }
          syncVideos(swiper);
        },
        { threshold: 0.2 }
      );

      observer.observe(el);
      swiper.ctsObserver = observer;
    }

    /* Belt-and-suspenders for the same 0-size-at-init class of bug: re-measure
       on every real size change of the carousel's own box, regardless of why
       it changed (iframe resize, device-preview toggle, sidebar collapsing).
       More reliable here than a window 'resize' listener, which doesn't fire
       for container-only resizes. */
    function observeSize(el, swiper) {
      if (!('ResizeObserver' in window)) return;

      var last = el.getBoundingClientRect().width;
      var observer = new ResizeObserver(function (entries) {
        var width = entries[0].contentRect.width;
        if (Math.round(width) === Math.round(last) || width === 0) return;
        last = width;
        swiper.update();
        recenter(swiper);
      });

      observer.observe(el);
      swiper.ctsResizeObserver = observer;
    }

    /* Re-apply the centered translate for whatever slide is currently active,
       without changing which slide it is. centeredSlides only positions the
       track on slide-change, so after a silent resize (theme editor iframe,
       fonts loading, images settling) the active card can drift off-centre —
       this snaps it back so the enlarged card stays in the middle. */
    function recenter(swiper) {
      if (!swiper || swiper.destroyed) return;
      if (swiper.params.loop) {
        swiper.slideToLoop(swiper.realIndex || 0, 0, false);
      } else {
        swiper.slideTo(swiper.activeIndex || 0, 0, false);
      }
    }

    function build(el) {
      if (!window.Swiper || instances.has(el)) return;

      var root = el.closest('.c-testimonials-swiper');
      var slideCount = parseInt(el.dataset.slideCount, 10) || 0;
      var reduced = prefersReducedMotion();

      /* "Wrap" (rewind), NOT Swiper's loop mode. loop:true reorders the slides
         and, with centeredSlides + slidesPerView:'auto' + few slides, leaves the
         active slide near the start so "centering" it pins the enlarged card to
         the left (verified live: activeIndex at x≈-42 instead of centered).
         rewind wraps at the ends without reordering, so centeredSlides works. */
      var wrap = el.dataset.loop === 'true' && slideCount > 1;
      var autoplayOn = el.dataset.autoplay === 'true' && !reduced && slideCount > 1;
      var autoplayDelay = parseInt(el.dataset.autoplayDelay, 10) || 5000;
      var initialSlide = parseInt(el.dataset.initialSlide, 10) || 0;

      var prevEl = root && root.querySelector('[data-cts-prev]');
      var nextEl = root && root.querySelector('[data-cts-next]');
      var paginationEl = root && root.querySelector('[data-cts-pagination]');

      var swiper;
      try {
        swiper = new Swiper(el, {
          slidesPerView: 'auto',
          centeredSlides: true,
          /* The visible 32px gutter is spaceBetween plus the idle card's inset
             inside its slide box ((448 - 400) / 2 = 24 at full size). */
          spaceBetween: 8,
          speed: reduced ? 0 : 500,
          grabCursor: true,
          watchSlidesProgress: true,
          slideToClickedSlide: true,
          loop: false,
          rewind: wrap,
          /* Open on the middle slide so the enlarged/active card is the centered
             one on load, per the Figma. default_active_index is computed in
             Liquid as the middle block. */
          initialSlide: initialSlide,
          keyboard: { enabled: true, onlyInViewport: true },
          navigation: prevEl && nextEl
            ? { prevEl: prevEl, nextEl: nextEl, disabledClass: 'swiper-button-disabled' }
            : false,
          pagination: paginationEl
            ? { el: paginationEl, clickable: true }
            : false,
          autoplay: autoplayOn
            ? { delay: autoplayDelay, disableOnInteraction: false, pauseOnMouseEnter: true }
            : false,
          on: {
            init: syncVideos,
            slideChangeTransitionStart: syncVideos
          }
        });
      } catch (err) {
        /* Fail loud in the console instead of silently leaving the carousel
           static - the CSS fallback (:not(.swiper-initialized)) still shows
           the center card correctly even when this throws. */
        if (window.console) console.error('[c-testimonials-swiper] Swiper failed to initialize:', err);
        return;
      }

      /* Re-measure once more right after creation: if the container had no
         real size yet (still true even with our checks above, in some hosts),
         the constructor's own initial calc can be stale by the time layout
         settles a frame later. */
      requestAnimationFrame(function () { swiper.update(); recenter(swiper); });
      window.addEventListener('load', function () { swiper.update(); recenter(swiper); }, { once: true });

      instances.set(el, swiper);
      observeVisibility(el, swiper, autoplayOn);
      observeSize(el, swiper);
    }

    function initAll(scope) {
      (scope || document).querySelectorAll(SELECTOR).forEach(build);
    }

    function destroyAll(scope) {
      scope.querySelectorAll(SELECTOR).forEach(function (el) {
        var swiper = instances.get(el);
        if (!swiper) return;
        if (swiper.ctsObserver) swiper.ctsObserver.disconnect();
        if (swiper.ctsResizeObserver) swiper.ctsResizeObserver.disconnect();
        swiper.destroy(true, true);
        instances.delete(el);
      });
    }

    function onReady(callback) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback, { once: true });
      } else {
        callback();
      }
    }

    onReady(function () {
      /* The Swiper bundle is a deferred script, so it has already run by
         DOMContentLoaded. The load fallback only covers a slow/blocked bundle. */
      if (window.Swiper) initAll();
      else window.addEventListener('load', function () { initAll(); }, { once: true });
    });

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-timer-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const timerBanners = document.querySelectorAll('.c-timer-banner');

    timerBanners.forEach(function (banner) {
      const startDateStr = banner.dataset.startDate;
      const endDateStr = banner.dataset.endDate;
      const timezone = banner.dataset.timezone || 'America/New_York';

      if (!endDateStr || typeof luxon === 'undefined') {
        console.warn('C Timer Banner: Missing end date or Luxon library not loaded');
        return;
      }

      const DateTime = luxon.DateTime;
      const startDate = startDateStr ? DateTime.fromISO(startDateStr, { zone: timezone }) : null;
      const endDate = DateTime.fromISO(endDateStr, { zone: timezone });

      if (!endDate.isValid) {
        console.warn('C Timer Banner: Invalid end date format');
        return;
      }

      const daysEl = banner.querySelector('[data-timer-days]');
      const hoursEl = banner.querySelector('[data-timer-hours]');
      const minutesEl = banner.querySelector('[data-timer-minutes]');
      const secondsEl = banner.querySelector('[data-timer-seconds]');

      // Widget elements
      const widgetDaysEl = banner.querySelector('[data-widget-days]');
      const widgetHoursEl = banner.querySelector('[data-widget-hours]');
      const widgetMinutesEl = banner.querySelector('[data-widget-minutes]');
      const widgetSecondsEl = banner.querySelector('[data-widget-seconds]');

      // Watch for mega menu scroll state
      const megaMenu = document.querySelector('.c-mega-menu');
      if (megaMenu) {
        const observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if (mutation.attributeName === 'class') {
              if (megaMenu.classList.contains('is-scrolled')) {
                banner.classList.add('c-timer-banner--scrolled');
              } else {
                banner.classList.remove('c-timer-banner--scrolled');
              }
            }
          });
        });
        observer.observe(megaMenu, { attributes: true });

        // Initial check
        if (megaMenu.classList.contains('is-scrolled')) {
          banner.classList.add('c-timer-banner--scrolled');
        }
      }

      function updateTimer() {
        const now = DateTime.now();

        // Check if countdown should be visible
        if (startDate && startDate.isValid && now < startDate) {
          banner.classList.add('c-timer-banner--hidden');
          return;
        }

        if (now > endDate) {
          banner.classList.add('c-timer-banner--hidden');
          return;
        }

        banner.classList.remove('c-timer-banner--hidden');

        const diff = endDate.diff(now, ['days', 'hours', 'minutes', 'seconds']);

        const days = Math.floor(diff.days);
        let hours = Math.floor(diff.hours);
        const minutes = Math.floor(diff.minutes);
        const seconds = Math.floor(diff.seconds);

        // If days element is not shown, add days to hours
        if (!daysEl) {
          hours = days * 24 + hours;
        }

        if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
        if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
        if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
        if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');

        // Update widget timer
        if (widgetDaysEl) widgetDaysEl.textContent = String(days).padStart(2, '0');
        if (widgetHoursEl) widgetHoursEl.textContent = String(hours).padStart(2, '0');
        if (widgetMinutesEl) widgetMinutesEl.textContent = String(minutes).padStart(2, '0');
        if (widgetSecondsEl) widgetSecondsEl.textContent = String(seconds).padStart(2, '0');
      }

      updateTimer();
      setInterval(updateTimer, 1000);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-title-grid-darias"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initTitleGridDarias(sectionEl) {
      var slider = sectionEl.querySelector('[data-tgd-slider]');
      var pagination = sectionEl.querySelector('[data-tgd-pagination]');

      if (!slider || !pagination) return;

      var dots = pagination.querySelectorAll('.c-title-grid-darias__dot');
      var cards = slider.querySelectorAll('.c-title-grid-darias__card');

      if (dots.length === 0 || cards.length === 0) return;

      function updateActiveDot() {
        var scrollLeft = slider.scrollLeft;
        var cardWidth = cards[0].offsetWidth;
        if (cardWidth === 0) return;
        var activeIndex = Math.round(scrollLeft / cardWidth);

        dots.forEach(function (dot, index) {
          dot.classList.toggle('is-active', index === activeIndex);
        });
      }

      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          var cardWidth = cards[0].offsetWidth;
          slider.scrollTo({ left: cardWidth * index, behavior: 'smooth' });
        });
      });

      var scrollTimeout;
      slider.addEventListener('scroll', function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(updateActiveDot, 50);
      });

      updateActiveDot();
    }

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.c-title-grid-darias').forEach(function (el) {
        initTitleGridDarias(el);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
